// extracted by mini-css-extract-plugin
export default {"app":"UtooK_8tRhpzR8r4Wc_G"};